import { User } from "oidc-client";
import { Observable } from "rxjs";
import AjaxHelper from "./AjaxHelper";
import { AjaxResponse } from "rxjs/internal/ajax/AjaxResponse";

class EventsService {
    public static GetEventsStrings$(user: User): Observable<string[]> {
        return AjaxHelper.AjaxGet$(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Events/GetEventsStrings',
            AjaxHelper.CreateHttpHeaders(user)
        )
    }

    public static LogAuditorDownloadEvent$(user: User, subId: string, downloadName: string, component: string): Observable<AjaxResponse<any>> {
        return AjaxHelper.AjaxPost(process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Events/LogAuditorDownloadEvent',
            {
                'SubmissionId': subId,
                'DownloadName': downloadName,
                'Component': component
            },
            AjaxHelper.CreateHttpHeaders(user)
        )
    }

}

export default EventsService;
